import Button from 'devextreme-react/button';
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useTitle } from '../../../../contexts/title';
import '../../../../css/dashboard.scss';
import { useGetStatistics } from '../../../../api/statistics';
import { useAuth } from '../../../../contexts/auth';
import { LoadPagePanel } from '../../../../components';
import { ActionRequiredCard } from '../../../common';

export default function ServiceProviderDashboard() {
	const navigate = useNavigate();
	const pageTitle = useTitle();

	useEffect(() => {
		pageTitle.setTitle('Action Required Items');
	}, [pageTitle])

	const { user } = useAuth();
	const statistics = useGetStatistics(user?.companyId!, user?.userName!, user?.companyTypeId!);

	return (
		<>
			<div className='content-block dashboard'>
				<LoadPagePanel visible={statistics.isLoading || statistics.isFetching} />

				{!statistics.isLoading &&
					<div className='dashboard-section no-header'>
						<Button
							type='default'
							text="View in Table"
							icon="Inscyth-Action-Required"
							className='view-in-table-button' onClick={() => navigate('/service-provider/action-required')}>
						</Button>
						<div className='ar-buttons-container'>
							<ActionRequiredCard
								text='Enter Service Initiated Date'
								statData={statistics.data}
								statID={370}
								url='/service-provider/action-required-orders/370'
								showPending={false}
								description={
									<div className='ar-description'>
										<div className='ar-description-active'>
											Active Orders: Orders received in the past two business days.
										</div>
										<div className='ar-description-pastdue'>
											Past Due Orders: Orders received more than two business days ago.
										</div>
									</div>
								}
							/>
							<ActionRequiredCard
								text='Invoice'
								statData={statistics.data}
								statID={380}
								url='/service-provider/action-required-orders/380'
								showPending={false}
								description={
									<div className='ar-description'>
										<div className='ar-description-active'>
											Active Orders:  Orders with a "Service Initiated Date" in the past two business days and today.
										</div>
										<div className='ar-description-pastdue'>
											Past Due orders: Orders with a "Service Initiated Date" more than two business days ago.
										</div>
									</div>
								}
							/>
						</div>
					</div>
				}
			</div>
		</>)
}
